module.exports = __webpack_public_path__ + "static/media/06.366a9257.png";